module.exports = __webpack_public_path__ + "media/images/forms-icons/text-icon-hover-4e392eca5c4bd11708c911dd1dcd89df.svg";